'use strict';

import execute_on from "../../../libs/execute-on";
import {getCsrfToken} from "../../../plugins/get-csrf-token";
import {swalErrorFire} from "../../../plugins/sweet-alert/sweet-alert-default";

execute_on('panel.company.edit', function () {
    $("#forced_mfa").on('change', function () {
        const $checkbox = $(this);
        $.ajax({
            method: "PUT",
            headers: {'X-CSRF-TOKEN': getCsrfToken()},
            url: $checkbox.data('url'),
            data: {
                forced_mfa: $checkbox.is(':checked')
            },
            complete: function(xhr) {
                if (202 !== xhr.status) {
                    swalErrorFire({
                        title: 'Company data cannot be saved.',
                    });
                }
            }
        });
    });
});
